/**
 * Global Validation & Error Message Dictionary
 * * Source of Truth: Centralizes all human-readable feedback strings to 
 * ensure UX consistency across enrollment and authentication flows.
 */

export const ERROR_MESSAGES = {
    // ================= COMMON FIELDS =================
    // Enforces presence of core identification metadata
    NAME_REQUIRED: "Name is required",
    ORG_REQUIRED: "Organization is required",
    BUSINESS_NAME_REQUIRED: "Business name is required",
    BUSINESS_NAME_TOO_SHORT: "Business name must be at least 2 characters",
    BUSINESS_NAME_TOO_LONG: "Business name must be at most 120 characters",
    COUNTRY_REQUIRED: "Country is required",

    // ================= EMAIL VALIDATION =================
    // Cascading feedback for the email input lifecycle
    EMAIL_REQUIRED: "Email is required",
    EMAIL_INVALID: "Invalid Email Address",

    // ================= PASSWORD VALIDATION =================
    // Security constraints for credential creation and verification
    PASSWORD_REQUIRED: "Password is required",
    PASSWORD_WEAK: "Min 8 characters with one uppercase, one lowercase, one number, and one special character.",
    PASSWORD_MISMATCH: "Passwords do not match",

    // ================= PHONE NUMBER VALIDATION =================
    // Telephony-specific validation strings
    PHONE_REQUIRED: "Mobile number is required",

    /** * Dynamic Length Validation:
     * A closure that generates localized feedback based on regional 
     * phone number standards (e.g., 10 digits for India).
     */
    PHONE_INVALID: (len: number) => `Must be ${len} digits`,


    // ================= PROFILE IMAGE =================
    /** * Biometric Enrollment Guard:
     * Critical for face recognition systems; ensures a high-fidelity image 
     * is captured before proceeding with registration.
     */
    PHOTO_REQUIRED: "Profile photo is required",
};